/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Changes_TitleInputs */

const da_privacy_changes_title = /** @type {(inputs: Privacy_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringer`)
};

/** @type {(inputs: Privacy_Changes_TitleInputs) => LocalizedString} */
const en_privacy_changes_title = da_privacy_changes_title;

/**

* @param {Privacy_Changes_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_changes_title = /** @type {((inputs?: Privacy_Changes_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Changes_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_changes_title(inputs)
	return /** @type {LocalizedString} */ ("Ændringer")
});